import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';

export const fetchSitesList = ({
  archived,
  securityCompanyId,
  businessClient,
  inductionRequired,
  search,
  from,
  fetchAll,
  departmentId,
  allUnarchived = false,
}) => {
  let query = `/regions/sites?securityCompanyId=${securityCompanyId}`;
  if (!fetchAll) {
    query += `&limit=50`;
  }
  if (allUnarchived) {
    query += `&allUnarchived=${allUnarchived}`;
  }
  if (departmentId === 'EMPTY_DEPARTMENT') {
    query += `&departmentId=${''}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (from) query += `&from=${from}`;
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (inductionRequired) query += `&inductionRequired=${inductionRequired}`;
  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};
export const fetchSiteDetails = siteId =>
  axiosGetWithCookies(`/regions/sites/${siteId}`);
export const createSite = site =>
  axiosPostWithCookies('/regions/sites', {
    data: site,
  });
export const updateSite = (id, site) =>
  axiosPutWithCookies(`/regions/sites/${id}`, {
    data: site,
  });
